import { BSpinner } from './spinner';
import { pluginFactory } from '../../utils/plugins';
var SpinnerPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BSpinner: BSpinner
  }
});
export { SpinnerPlugin, BSpinner };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/spinner/index.js
// module id = 356
// module chunks = 0